import { Logo } from "./Logo";
import { MapPin, Phone } from "lucide-react";

export const PortalFooter = () => {
  return (
    <footer
      className="border-t border-[#E5E7EB] bg-white mt-24"
      data-testid="portal-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <Logo />
          <p className="mt-4 text-sm text-[#6B7280] max-w-xs leading-relaxed">
            Global Thinkers. Engaged Leaders. Mahindra University fosters
            interdisciplinary thinking, research and leadership.
          </p>
        </div>
        <div>
          <div className="tiny-label mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-[#6B7280]">
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0" />
              <span>
                Survey No. 62/1A, Bahadurpally Jeedimetla, Hyderabad, Telangana
                500043
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4" />
              <a href="tel:+914067135100" className="hover:text-[#111]">
                +91 40 6713 5100
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div className="tiny-label mb-4">Registration Cell</div>
          <ul className="space-y-2 text-sm text-[#6B7280]">
            <li>Registration Portal — 2026</li>
            <li>Admissions Office, Ground Floor, Main Block</li>
            <li>Hours: Mon–Sat · 9:30 AM – 5:30 PM</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#9CA3AF]">
            © 2026 Mahindra University. All rights reserved.
          </p>
          <p className="text-xs text-[#9CA3AF]">
            Privacy · Terms · Accessibility
          </p>
        </div>
      </div>
    </footer>
  );
};
